import { appToast } from 'components/Basic/CustomToast';
import { updateRoofToolFacet } from 'components/tool/Editor/ButtonDiv/api';
import { useMutation } from 'react-query';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { LinesData } from 'store/slices/RoofToolLinesSlice/types';

export default function useUpdateRoofTool() {
	const { uuid, designType } = useSelector((state: RootState) => state.roofData.data);
	const { createSpecialEdges, updateSpecialEdges } = useSelector((state: RootState) => state.roofToolLines.data);
	const hasDetectedEdgesConfirmed = useSelector((state: RootState) => state.roofToolLines.autoEdgeDetection.confirmed);
	
	const createSpecialEdgesData = createSpecialEdges.map(line => ({
		...line,
		edges: line.edges
			.filter(edge => edge.discard === false)
			.map(({ discard, ...rest }) => rest)
	})).filter(eachSeg => eachSeg.edges.length > 0);
	
	const updateSpecialEdgesData = updateSpecialEdges.map(line => ({
		...line,
		edges: line.edges
			.filter(edge => edge.discard === false)
			.map(({ discard, ...rest }) => rest)
	})).filter(eachSeg => eachSeg.edges.length > 0);

	return useMutation(
		'update-roof-tool-facet',
		async () => {
			const payload: Partial<LinesData> & {
				autoDetectedEdgesEnabled?: boolean;
			} = {
				createSpecialEdges: createSpecialEdgesData,
				updateSpecialEdges: updateSpecialEdgesData,
			};

			if(hasDetectedEdgesConfirmed){
				payload.autoDetectedEdgesEnabled = hasDetectedEdgesConfirmed;
			}

			await updateRoofToolFacet(payload, uuid, designType);
		},
		{
			onError() {
				const message = 'Something went wrong. Please fix your edits and try again';
				appToast.error(message);
			}
		}
	);
}